import { getIconByCategory } from 'utils/category';

import { DocumentModel } from 'api/documents/documents.model';
import { BasicCard } from 'components/BasicCard';
import Detail from 'components/Detail';
import GoToCertificateButton from 'components/GoToCertificateButton';
import { CertificateDetailsModel } from 'models/certificate.model';
import { CATEGORY_TYPE } from 'models/documents.model';

import * as Styled from './DetailsCard.styles';

const getCertificateDetailsByCategory = (category: CATEGORY_TYPE) => {
  switch (category) {
    case CATEGORY_TYPE.BATTERY_CELLS:
      return { title: 'Battery Cell Certificate', label: 'Battery Cells Batch No' };
    case CATEGORY_TYPE.BATTERY_TECH_REVIEW:
      return {
        title: 'Battery Pack Technical Review Certificate',
        label: 'Battery Pack Technical Review Certificate ID',
      };
    case CATEGORY_TYPE.BATTERY_PACKS_REPAIR:
      return {
        title: 'Battery Pack Repair Certificate',
        label: 'Battery Pack Repair Certificate ID',
      };
    case CATEGORY_TYPE.BATTERY_PACKS_RECYCLING:
      return {
        title: 'Battery Pack Recycling Certificate',
        label: 'Battery Pack Recycling Certificate ID',
      };
    case CATEGORY_TYPE.BATTERY_WASTE:
      return {
        title: 'Battery Pack Waste Certificate',
        label: 'Battery Pack Waste Certificate ID',
      };
    case CATEGORY_TYPE.BATTERY_REPURPOSE:
      return {
        title: 'Battery Pack Repurpose Certificate',
        label: 'Battery Pack Repurpose Certificate ID',
      };

    default:
      return {};
  }
};

const DetailsCard = ({
  additionalDetails,
  ...certificate
}: DocumentModel<CertificateDetailsModel>) => {
  const Icon = getIconByCategory(certificate.category)?.Icon;

  const { title, label = '' } = getCertificateDetailsByCategory(certificate.category);

  return (
    <BasicCard $height="100%" $padding="1rem">
      <Styled.CardTitle>
        {Icon && (
          <Styled.IconContainer>
            <Icon width="20" height="20" />
          </Styled.IconContainer>
        )}
        <Styled.Title>{title}</Styled.Title>
        <GoToCertificateButton documentBlockchainAddress={certificate.documentBlockchainAddress} />
      </Styled.CardTitle>
      <div>
        <Detail label={label} value={additionalDetails?.productId} />
      </div>
    </BasicCard>
  );
};

export default DetailsCard;
